import type { IconSvgObject } from './types';

const WifiLowSignalIcon: IconSvgObject = [
  ["path", { d: "M20.7487 6.42158C18.3521 4.50087 15.3102 3.35204 12 3.35204C8.68979 3.35204 5.64791 4.50087 3.25132 6.42158C2.49033 7.03146 2.41868 8.13176 2.99097 8.92141L11.1903 20.2348C11.5895 20.7857 12.4105 20.7857 12.8097 20.2348L21.009 8.92141C21.5813 8.13176 21.5097 7.03146 20.7487 6.42158Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15.179 16.9706C13.1261 16.1459 10.8811 16.1459 8.82812 16.9706", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default WifiLowSignalIcon;
